module.exports = __webpack_public_path__ + "static/img/4539_phase_function_Paper_Points.e849515.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4539_phase_function_Paper_Points.png
// module id = ZtTh
// module chunks = 0